module.exports = __webpack_public_path__ + "img/70.6189a56a.png";